import { PAGES } from "utils/gtm/gtmEventsData"

export const TODOS_CONFIG = {
  [PAGES.client_detail_page]: {
    columnsToHide: ["client"],
    showFilters: false,
    removeTabs: true,
    actionsToHide: ["call", "email", "whatsapp", "logs"],
    addExtraSpaceToFirstColumn: true,
    skeletonType: "small",
  },
  [PAGES.client_listing_page]: {
    columnsToHide: [],
    showFilters: true,
    removeTabs: false,
    skeletonType: "large",
  },
}
